module.exports = __webpack_public_path__ + "img/three1Green.9d722743.png";